var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayL48Line = function SvgIconPlayL48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 33.8V14.2c0-1.04.56-2 1.46-2.52.9-.52 2.02-.51 2.91.02l16.6 9.8c.89.53 1.43 1.46 1.43 2.5s-.53 1.97-1.43 2.5l-16.6 9.8c-.9.53-2.01.54-2.91.02-.9-.51-1.46-1.48-1.46-2.52ZM17 15.08v17.84L32.12 24 17 15.08Z",
    fill: "current"
  })));
};
export default SvgIconPlayL48Line;